<template>
  <a v-if="!disabled" :href="to" @click="closeDrawer"
    ><slot>{{ text }}</slot></a
  >
  <span
    v-else
    class="link"
    :disabled="disabled"
    :class="{ 'disabled-link': disabled }"
    ><slot>{{ text }}</slot></span
  >
</template>

<script>
export default {
  props: {
    to: {
      type: String,
      default: ""
    },
    text: {
      type: [String, Number],
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ["closeDrawer"],
  methods: {
    closeDrawer() {
      this.$emit("closeDrawer");
    }
  }
};
</script>

<style lang="scss" scoped>
.disabled-link {
  opacity: 0.6;
}
</style>
